/* eslint-disable max-len */
import React, {
  useState, useRef, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import CallBackCard from './callbackCard';

export default function CourseSection({
  heading, content, entityId, entityType, brochureLink,
}) {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = brochureLink;
    link.target = '_blank';
    link.download = brochureLink;
    link.click();
  };

  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef(null);

  const COLLAPSED_HEIGHT = 290;

  useEffect(() => {
    if (contentRef.current) {
      setIsOverflowing(
        contentRef.current.scrollHeight > COLLAPSED_HEIGHT,
      );
    }
  }, [content]);

  return (
    <div className="w-full px-5 md:px-[52px]">
      <div className="w-full">
        <div className="w-full lg:w-[417px] lg:float-right lg:ml-8 lg:mb-4 hidden md:block">
          <CallBackCard entityId={entityId} entityType={entityType} />
        </div>
        {heading && <div dangerouslySetInnerHTML={{ __html: heading }} />}

        <div className="text-sm md:text-[14px] leading-relaxed text-justify text-black w-full styled-list my-3">

          <div
            ref={contentRef}
            style={{
              maxHeight: expanded ? 'none' : `${COLLAPSED_HEIGHT}px`,
              overflow: expanded ? 'visible' : 'hidden',
              transition: 'all 0.3s ease',
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />

        </div>

        {isOverflowing && (
          <button
            type="button"
            onClick={() => setExpanded((prev) => !prev)}
            className="text-[14px] sm:text-[15px] md:text-[16px] font-medium text-red-500 whitespace-nowrap"
          >
            {expanded ? 'Read Less' : 'Read More...'}
          </button>
        )}
        {' '}
        <br />

        {
          brochureLink && (
            <button
              onClick={handleDownload}
              type="button"
              className="mt-8 bg-transparent border lg:border-2 px-3 py-2 border-customBlue inline-flex w-fit text-sm lg:text-sm xl:text-base font-bold text-customBlue items-center"
            >
              <span className="pe-2">
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.0834961 10.5C0.0834961 5.58951 0.083496 3.13428 1.60899 1.6088C3.13446 0.0833129 5.58969 0.083313 10.5002 0.083313C15.4106 0.083313 17.8659 0.0833129 19.3913 1.6088C20.9168 3.13428 20.9168 5.58951 20.9168 10.5C20.9168 15.4104 20.9168 17.8657 19.3913 19.3911C17.8659 20.9166 15.4106 20.9166 10.5002 20.9166C5.58969 20.9166 3.13446 20.9166 1.60899 19.3911C0.083496 17.8657 0.0834961 15.4104 0.0834961 10.5ZM10.5002 4.5104C10.9316 4.5104 11.2814 4.86018 11.2814 5.29165V10.6972L13.0728 8.90592C13.3779 8.60081 13.8725 8.60081 14.1776 8.90592C14.4827 9.21102 14.4827 9.70561 14.1776 10.0107L11.0526 13.1357C10.9061 13.2823 10.7074 13.3646 10.5002 13.3646C10.293 13.3646 10.0942 13.2823 9.94777 13.1357L6.82274 10.0107C6.51764 9.70561 6.51764 9.21102 6.82274 8.90592C7.12783 8.60081 7.6225 8.60081 7.92759 8.90592L9.71891 10.6972V5.29165C9.71891 4.86018 10.0687 4.5104 10.5002 4.5104ZM6.3335 14.9271C5.90203 14.9271 5.55225 15.2769 5.55225 15.7083C5.55225 16.1398 5.90203 16.4896 6.3335 16.4896H14.6668C15.0983 16.4896 15.4481 16.1398 15.4481 15.7083C15.4481 15.2769 15.0983 14.9271 14.6668 14.9271H6.3335Z"
                    fill="#0267B1"
                  />
                </svg>
              </span>
              Download Brochure
            </button>
          )
        }

        <div className="clear-both" />
        <div className="md:hidden mt-6">
          <CallBackCard entityId={entityId} entityType={entityType} />
        </div>
      </div>
    </div>
  );
}

CourseSection.propTypes = {
  heading: PropTypes.string,
  content: PropTypes.string,
  entityId: PropTypes.string.isRequired,
  entityType: PropTypes.string.isRequired,
  brochureLink: PropTypes.string,
};
